"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _each = _interopRequireDefault(require("lodash/each"));

var _cookieHelper = require("../helpers/cookie-helper");

/**
 * Analytics Server Where you can register a analytics logger.
 * All analytics loggers will implements the same functions, login, logout, trackPageView, trackEvent
 *
 * @export AnalyicsService
 * @class AnalyicsService
 */
var AnalyicsService = /*#__PURE__*/function () {
  function AnalyicsService(analyticsLoggers) {
    (0, _classCallCheck2["default"])(this, AnalyicsService);

    // Only Add Analytics Loggers when not local!
    if (process.env.isProd) {
      this.analyticsLoggers = analyticsLoggers;
    } else {
      this.analyticsLoggers = [];
    }

    this._callAnalyticsLoggers('init');
  }

  (0, _createClass2["default"])(AnalyicsService, [{
    key: "handleLoginAndServerAnalyticsEvents",
    value: function handleLoginAndServerAnalyticsEvents(analyticsEvents, accountId, globalIdentity, name, email, isFreeAccount, externalId, landerType) {
      var _this = this;

      this.login(name, email, accountId, landerType, globalIdentity);

      if (analyticsEvents) {
        (0, _each["default"])(analyticsEvents, function (type) {
          switch (type) {
            case 'AccountJoined':
              _this.trackEvent('AccountJoined', {
                isFree: isFreeAccount,
                globalIdentity: globalIdentity,
                accountId: accountId,
                externalId: externalId,
                landerType: landerType
              });

          }
        });
      }
    }
    /**
     * Triggered when a user logged in
     *
     *
     * @memberOf AnalyicsService
     */

  }, {
    key: "login",
    value: function login(name, email, accountId, landerType) {
      this._callAnalyticsLoggers('login', arguments);

      var userId = "".concat(accountId, "_").concat(landerType);
      (0, _cookieHelper.setCookie)('userId', userId, 365);
    }
    /**
     * Triggered when a user logged out
     *
     *
     * @memberOf AnalyicsService
     */

  }, {
    key: "logout",
    value: function logout() {
      this._callAnalyticsLoggers('logout', arguments);
    }
    /**
     * Trigger this when we have a pageview
     *
     * @param {any} path , page path
     *
     * @memberOf AnalyicsService
     */

  }, {
    key: "trackPageView",
    value: function trackPageView(path) {
      // only track a new page view if it really is a new page view. do not track twice the same page.
      // this could be triggered to often. when only a query string is changing its triggering an extra page view, we dont want that
      if (path !== this.prevPath) {
        this.prevPath = path;

        this._callAnalyticsLoggers('trackPageView', arguments);
      }
    }
    /**
     * Trigger this on a event that you want to log
     *
     * @param {any} action - tag, string
     * @param {any} obj - propertybag, js object
     *
     * @memberOf AnalyicsService
     */

  }, {
    key: "trackEvent",
    value: function trackEvent(action, obj) {
      this._callAnalyticsLoggers('trackEvent', arguments);
    }
  }, {
    key: "trackAddToCart",
    value: function trackAddToCart(product) {
      this._callAnalyticsLoggers('trackAddToCart', arguments);
    }
  }, {
    key: "trackRemoveFromCart",
    value: function trackRemoveFromCart() {
      this._callAnalyticsLoggers('trackRemoveFromCart', arguments);
    }
  }, {
    key: "trackClearCart",
    value: function trackClearCart() {
      this._callAnalyticsLoggers('trackClearCart', arguments);
    }
  }, {
    key: "trackCheckout",
    value: function trackCheckout(products) {
      this._callAnalyticsLoggers('trackCheckout', arguments);
    }
  }, {
    key: "trackEcommercePurchase",
    value: function trackEcommercePurchase(orderId, totalPriceExTax, totalTax, status, products) {
      this._callAnalyticsLoggers('trackEcommercePurchase', arguments);
    }
  }, {
    key: "trackUserDomains",
    value: function trackUserDomains(_ref) {
      var linkedDomainsCount = _ref.linkedDomainsCount,
          registeredDomainsCount = _ref.registeredDomainsCount,
          domainsCount = _ref.domainsCount,
          assignedDomainsCount = _ref.assignedDomainsCount,
          unassignedDomainsCount = _ref.unassignedDomainsCount;

      this._callAnalyticsLoggers('trackUserDomains', arguments);
    }
    /**
     * Set global propeties that will be send using every future request.
     *
     * @param {any} action - tag, string
     * @param {any} obj - propertybag, js object
     *
     * @memberOf AnalyicsService
     */

  }, {
    key: "setGlobalProperties",
    value: function setGlobalProperties(obj) {
      this._callAnalyticsLoggers('setGlobalProperties', arguments);
    }
    /**
     * Will call all the registed loggers, that where registed in the constructor
     *
     * @param {any} type - event that was triggered (login, logout, trackPageView, trackEvent)
     * @param {any} args - args from the triggered event
     *
     * @memberOf AnalyicsService
     */

  }, {
    key: "_callAnalyticsLoggers",
    value: function _callAnalyticsLoggers(type, args) {
      (0, _each["default"])(this.analyticsLoggers, function (logger) {
        if (typeof logger[type] === 'function') {
          logger[type].apply(logger, args);
        }
      });
    }
  }]);
  return AnalyicsService;
}();

exports["default"] = AnalyicsService;